import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { DeviceUp } from "../../theme/breakpoints";

export const IframeWrapper = styled(Box)`
  width: 100%;
  height: 100%;
  position: relative;

  .popout-overlay {
    position: absolute;
    top: 0;
    right: 0;
    width: 50px;
    height: 50px;
    background: rgba(255, 255, 255, 1);
    z-index: 10;
    padding: 5px;

    img {
      max-width: 100%;
      height: auto;
    }

    @media ${DeviceUp.sm} {
      display: none;
    }
  }
`;
